export const queryKeys = {
  PRO_PRICE: 'pro-price',
  PACKAGE_PRICE: 'package-price',
  SEND_FEEDBACK: 'send-feedback'
};
